'use client';

import { HamburgerIcon } from '@repo/icons';
import { Button } from '@repo/ui/button';
import { cn } from '@repo/utils/cn';
import { useTranslations } from 'next-intl';
import { memo } from 'react';
import { UnStyledLink } from '@/components/common/link';
import { usePathname } from '@/i18n/routing';
import { useAppStore } from '@/providers/AppStoreProvider';

const HeaderSidebarActionButtons = () => {
  const t = useTranslations('sidebar');
  const pathname = usePathname();

  const isCasino = pathname.startsWith('/casino') || pathname.includes('/game');

  const isSportsBook = pathname.startsWith('/sportsbook');

  const { sidebarOpen, toggleSidebar } = useAppStore((state) => ({
    sidebarOpen: state.sidebarOpen,
    toggleSidebar: state.toggleSidebar,
  }));

  return (
    <div
      className={cn(
        'hidden h-full min-w-[65px] items-center justify-around border-r border-[var(--surface-lighter-bg)] sm:flex',
        {
          'min-w-[240px]': sidebarOpen,
        }
      )}
    >
      <Button
        variant="secondary"
        onClick={() => toggleSidebar(!sidebarOpen)}
        className="!border-1 !atoms-btn-secondary-bg m-0 hidden h-10 w-10 items-center justify-center rounded-full p-0 vt-atoms-btn-secondary-stroke sm:flex"
      >
        <HamburgerIcon />
      </Button>
      {sidebarOpen && (
        <div className="flex items-center justify-center rounded-lg border border-[var(--surface-lighter-bg)] p-1">
          <UnStyledLink href="/casino">
            <Button
              variant="blank"
              className={cn(
                'text-size-medium rounded-lg rounded-r-none font-bold vt-font-highlight-font-family !vt-main-menu-item-text !vt-main-menu-item-bg hover:!vt-main-menu-item-text-active hover:!vt-main-menu-item-bg-active',
                isCasino && '!vt-main-menu-item-text-active !vt-main-menu-item-bg-active'
              )}
            >
              {t('casino')}
            </Button>
          </UnStyledLink>
          <UnStyledLink href="/sportsbook">
            <Button
              variant="blank"
              className={cn(
                'text-size-medium rounded-lg rounded-l-none font-bold vt-font-highlight-font-family !vt-main-menu-item-text !vt-main-menu-item-bg hover:!vt-main-menu-item-text-active hover:!vt-main-menu-item-bg-active',
                isSportsBook && '!vt-main-menu-item-text-active !vt-main-menu-item-bg-active'
              )}
            >
              {t('sports')}
            </Button>
          </UnStyledLink>
        </div>
      )}
    </div>
  );
};

export default memo(HeaderSidebarActionButtons);
